import { FC, ReactNode } from 'react';
import styles from './QuickLinkTile.module.scss';

export interface QuickLinkTileProps {
  title: string;
  subtitle: string;
  icon?: ReactNode;
  href?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

export const QuickLinkTile: FC<QuickLinkTileProps> = ({
  title,
  subtitle,
  icon,
  href = '#',
  onClick,
}) => {
  return (
    <a href={href} className={styles.tile} onClick={onClick}>
      <div className={styles.iconWrapper} aria-hidden="true">
        {icon || '—'}
      </div>
      <div className={styles.textGroup}>
        <span className={styles.title}>{title}</span>
        <span className={styles.subtitle}>{subtitle}</span>
      </div>
    </a>
  );
};
